const DashedSeparator = ({
                             color = '#8C8C8C',
                             className = ''
                         }) => {
    return (
        <div
            className={`w-full border-t-2 border-dashed ${className}`}
            style={{
                borderColor: color
            }}
        />
    );
};

export default DashedSeparator;
